function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import CONSTANTS from './../../appConstants';
import CalendarModel from './../../models/calendar-model';
import CalendarDayModel from './../../models/calendar-day-model/';
import CalendarMonthModel from './../../models/calendar-month-model/';
import DateUtils from './../date-utils/';

/**
 * A namespace for calendar utility functions.
 *
 * @class CalendarUtils
 * @static
 */
var CalendarUtils = /*#__PURE__*/function () {
  function CalendarUtils() {
    _classCallCheck(this, CalendarUtils);
  }
  return _createClass(CalendarUtils, null, [{
    key: "buildCalendar",
    value:
    /**
     * Returns a CalendarModel that
     * represents the provided year.
     *
     * @method CalendarUtils.buildCalendar
     * @param {Number} year
     * @returns {CalendarModel} a CalendarModel
     */
    function buildCalendar(year) {
      var months = [];
      for (var i = 0; i < CONSTANTS.MONTHS_IN_A_YEAR; i++) {
        months.push(CalendarUtils.buildCalendarMonth(i, year));
      }
      return new CalendarModel().fromJSON({
        year: year,
        months: months
      }).toJSON();
    }

    /**
     * Returns a CalendarDayModel that
     * represents the provided date.
     *
     * @method CalendarUtils.buildDay
     * @param {Date} date
     * @returns {CalendarDayModel} a CalendarDayModel
     */
  }, {
    key: "buildDay",
    value: function buildDay(date) {
      var day = date.getDate();
      var dayOfWeek = date.getDay();
      var month = date.getMonth();
      var year = date.getFullYear();
      var dayNames = CONSTANTS.DAYS[dayOfWeek];
      var monthNames = CONSTANTS.MONTHS[month];
      return new CalendarDayModel().fromJSON({
        date: date,
        day: day,
        dayOfWeek: dayOfWeek,
        month: month,
        year: year,
        abbreviatedName: dayNames[1],
        isToday: DateUtils.datesMatch(date, new Date()),
        isWeekend: CalendarUtils.isWeekend(dayOfWeek),
        fullName: dayNames[0],
        monthName: monthNames[0],
        abbreviatedMonthName: monthNames[1]
      }).toJSON();
    }

    /**
     * Returns a padded CalendarMonthModel that
     * represents the provided month/year. Padded
     * calendar months contains "ghost days" which
     * even out the weeks in a display (think table).
     *
     * @method CalendarUtils.buildPaddedCalendarMonth
     * @param {Number} month - zero based
     * @param {Number} year
     * @returns {CalendarMonthModel} a CalendarMonthModel
     */
  }, {
    key: "buildPaddedCalendarMonth",
    value: function buildPaddedCalendarMonth(month, year) {
      var calendarMonth = CalendarUtils.buildCalendarMonth(month, year);
      var days = calendarMonth.days.slice();
      var padLeft = days[0].dayOfWeek;
      /**
       * subtract 1 from both days.length and days of the week,
       * because we're dealing with zero based numbers
       */
      var padRight = CONSTANTS.DAYS_IN_A_WEEK - 1 - days[days.length - 1].dayOfWeek;
      var ghostDaysLeft = CalendarUtils.getGhostDays(month - 1, year, 'end', padLeft);
      var ghostDaysRight = CalendarUtils.getGhostDays(month + 1, year, 'start', padRight);
      var totalDays = [].concat(_toConsumableArray(ghostDaysLeft), _toConsumableArray(days), _toConsumableArray(ghostDaysRight));
      return Object.assign(calendarMonth, {
        days: totalDays,
        weeks: CalendarUtils.getWeeks(totalDays)
      });
    }

    /**
     * Accepts a padded (ghost days included) array of days
     * and returns an array of weeks including said days.
     *
     * @method CalendarUtils.getWeeks
     * @param {CalendarDayModel[]} days - array of calendar day models
     * @returns {Array[]}
     */
  }, {
    key: "getWeeks",
    value: function getWeeks(days) {
      var daysCopy = days.slice();
      var numberOfWeeks = days.length / CONSTANTS.DAYS_IN_A_WEEK;
      var weeks = [];
      for (var i = 1; i <= numberOfWeeks; i++) {
        weeks.push(daysCopy.splice(0, CONSTANTS.DAYS_IN_A_WEEK));
      }
      return weeks;
    }

    /**
     * Returns a number of "ghost days", specified by howMany,
     * in the provided month/year extending from the provided position.
     *
     * @method CalendarUtils.getGhostDays
     * @param {Number} month
     * @param {Number} year
     * @param {String} position - 'end' or 'start'
     * @param {Number} howMany
     * @returns {Array} ghostDays - array of day models
     */
  }, {
    key: "getGhostDays",
    value: function getGhostDays(month, year, position, howMany) {
      var newMonth = month;
      var newYear = year;
      if (newMonth < 0) {
        newMonth = 11;
        newYear -= 1;
      } else if (newMonth > 11) {
        newMonth = 0;
        newYear += 1;
      }
      var ghostCalendarMonth = CalendarUtils.buildCalendarMonth(newMonth, newYear);
      var ghostDays = ghostCalendarMonth.days;
      if (position === 'start') {
        return ghostDays.slice(0, howMany);
      } else {
        /**
         * reverse the array so we get the final days,
         * then reverse again so that they're in the correct order
         */
        return ghostDays.reverse().slice(0, howMany).reverse();
      }
    }

    /**
     * Return a calendar month model that
     * represents the provided month/year.
     *
     * @method CalendarUtils.buildCalendarMonth
     * @param {Number} month
     * @param {Number} year
     * @returns {CalendarMonthModel} calendarMonthModel
     */
  }, {
    key: "buildCalendarMonth",
    value: function buildCalendarMonth(month, year) {
      var totalDays = CalendarUtils.daysInMonth(month, year);
      var days = [];
      var monthNames = CONSTANTS.MONTHS[month];
      for (var i = 1; i <= totalDays; i++) {
        days.push(CalendarUtils.buildDay(new Date(year, month, i)));
      }
      return new CalendarMonthModel().fromJSON({
        abbreviatedName: monthNames[1],
        days: days,
        daysOfTheWeek: CONSTANTS.DAYS.slice(),
        fullName: monthNames[0],
        month: month,
        year: year
      }).toJSON();
    }

    /**
     * Return the number of days
     * in the provided month/year.
     *
     * @method CalendarUtils.daysInMonth
     * @param {Number} month
     * @param {Number} year
     * @returns {Number}
     */
  }, {
    key: "daysInMonth",
    value: function daysInMonth(month, year) {
      return new Date(year, month + 1, 0).getDate();
    }

    /**
     * Return the day of week {0-6}
     * based of of the provided day/month/year.
     *
     * @method CalendarUtils.dayOfWeek
     * @param {Number} day
     * @param {Number} month
     * @param {Number} year
     * @returns {Number}
     */
  }, {
    key: "dayOfWeek",
    value: function dayOfWeek(day, month, year) {
      return new Date(year, month, day).getDay();
    }

    /**
     * Returns a boolean that determines
     * if the provided day is a weekend.
     *
     * @method CalendarUtils.isWeekend
     * @param {Number} day
     * @returns {Boolean}
     */
  }, {
    key: "isWeekend",
    value: function isWeekend(day) {
      return day === 6 || day === 0;
    }

    /**
     * Returns a boolean that determines whether
     * the provided day is a valid day. A valid day
     * is defined as a day that falls within its
     * months range. 06-40-1990 is not a valid day, as
     * there are not 40 days in June.
     *
     * @method CalendarUtils.isValidDay
     * @param {Number} day
     * @param {Number} month
     * @param {Number} year
     * @returns {Boolean}
     */
  }, {
    key: "isValidDay",
    value: function isValidDay(day, month, year) {
      return day >= 1 && day <= CalendarUtils.daysInMonth(month, year);
    }

    /**
     * Returns a boolean that determines whether
     * the provided month is a valid month number
     * (falls between 0 and 11).
     *
     * @method CalendarUtils.isValidMonth
     * @param {Number} month
     * @returns {Boolean}
     */
  }, {
    key: "isValidMonth",
    value: function isValidMonth(month) {
      return month >= 0 && month <= 11;
    }
  }]);
}();
export { CalendarUtils as default };